import CompanyRules from './CompanyRules';

export default (props) => {
  return <CompanyRules {...props} />;
};
